import { Check } from '#components/Check'
import { SuperCounter } from '#components/SuperCounter'
import { endpoints, request, selectors, usePop, useTasks } from '#hooks'
import {
  Button,
  PanelBody,
  PanelRow,
  Spinner,
  TextControl,
} from '@wordpress/components'
import { useEffect } from '@wordpress/element'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

export const MetaDescription = ({ pop }) => {
  const { t } = useTranslation()
  const { tasks, isValidating, mutate } = useTasks(pop)
  const { post } = usePop(pop)

  const condition = tasks?.['nodescsingle']

  const defaultValues = {
    description: '',
  }

  const { watch, handleSubmit, control, setValue } = useForm({
    defaultValues,
  })

  const updateWhenValue = () => {
    if (post) {
      setValue(
        'description',
        post.postMetaFields?.[selectors.description]?.[0] || ''
      )
    }
  }

  useEffect(updateWhenValue, [post])

  const sendDescription = (data) => {
    request(endpoints.meta.create({ postId: pop.id, data }))
      .then(() => {
        mutate()
      })
      .catch((error) => {
        console.log(error)
      })
  }

  return (
    <PanelBody
      title={t('sidebar.metadescription.title')}
      icon={isValidating ? <Spinner /> : <Check condition={condition} />}
      initialOpen={!condition}
    >
      <PanelRow>
        <form onSubmit={handleSubmit(sendDescription)}>
          <p>{t('sidebar.metadescription.intro')}</p>
          <Controller
            name="description"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextControl
                label={t('sidebar.metadescription.label')}
                {...field}
              />
            )}
          />
          <p>
            <SuperCounter value={watch('description')} />
          </p>
          <Button type="submit" variant="primary">
            {t('sidebar.metadescription.cta')}
          </Button>
        </form>
      </PanelRow>
    </PanelBody>
  )
}
